import { TransportModes } from '@nx-smartmonkey/shared/domain';

import BicycleIcon from '../assets/img/vehicle_types/bicycle.svg';
import CarIcon from '../assets/img/vehicle_types/car.svg';
import PedestrianIcon from '../assets/img/vehicle_types/pedestrian.svg';
import ScooterIcon from '../assets/img/vehicle_types/scooter.svg';
import TruckIcon from '../assets/img/vehicle_types/truck.svg';

export const getVehicleTypeIcon = (type: TransportModes) => {
  switch (type) {
    case `truck`:
      return TruckIcon;
    case `bicycle`:
      return BicycleIcon;
    case `pedestrian`:
      return PedestrianIcon;
    case `scooter`:
      return ScooterIcon;
    case `car`:
    default:
      return CarIcon;
  }
};
